<template>
    <div>
        <v-row justify="center">
            <v-col sm="12" md="12" lg="12">
                <div style="width:100%; position:relative; display:flex; align-items:flex-start;">
                    <v-select v-model="selectedType" item-text="Name" item-value="Pass" dense :items="typeList"
                        label="Search Type" outlined persistent-placeholder @change="onChangeTypeFun"></v-select>
                    <div v-if="showInfo && selectedType == '2'" class="tooltip info-tooltip"
                        style="margin-left:100%; margin-top:2px;">
                        <v-icon size="18" color="secondary" class="tooltip pl-1"
                            style="vertical-align: super; cursor:pointer;">mdi
                            mdi-information-slab-circle-outline</v-icon>
                        <span class="tooltiptext" style="min-width:260px;">Order Searches from the following:<br>Sales
                            Order #, RMA, RITM, Request #,<br>Customer #, Customer PO, Customer Order #,<br>Employee ID,
                            Employee Name,<br>Inbound Waybill, Outbound Waybill,<br>Inbound Device ID, Outbound Device
                            ID</span>
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    name: 'searchTypeBox',
    props: {
        showInfo: Boolean,
        onChangeType: Function,
        selectedType: String,

    },
    data() {
        return {
            
            typeList: [
                { Name: 'Equals To', Pass: '1' },
                { Name: 'Contains', Pass: '2' },
            ],
        }
    },
    mounted() {
        this.selectedType = this.selectedType || '1';
    },
    methods: {
        onChangeTypeFun() {
            this.$emit("onChangeType", this.selectedType);

        },
    }
}
</script>